/**
 * Builds a URL with path parameters and optional query parameters
 *
 * @param basePath - Base path without query parameters
 * @param queryParams - Object containing key-value pairs for query parameters
 * @returns Formatted URL string with query parameters
 */
export const buildUrl = (
  basePath: string,
  queryParams?: Record<string, string | number | boolean | undefined | null>
): string => {
  if (!queryParams) {
    return basePath;
  }

  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(queryParams)) {
    if (value !== undefined) {
      searchParams.append(key, String(value));
    }
  }

  const queryString = searchParams.toString();

  return queryString ? `${basePath}?${queryString}` : basePath;
};

export type Environment =
  | 'Development'
  | 'Staging'
  | 'Production'
  | 'Localhost';

export const Environments = {
  Development: 'Development' as const,
  Staging: 'Staging' as const,
  Production: 'Production' as const,
  Localhost: 'Localhost' as const,
} as const;

export const currentEnvironment: Environment =
  (import.meta.env.VITE_ENVIRONMENT as Environment) || 'Localhost';

export const isDevOrLocalEnvironment =
  currentEnvironment === Environments.Development ||
  currentEnvironment === Environments.Localhost;
